"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drillDownDisplayForm = exports.drillDownFromAttributeLocalId = void 0;
function drillDownFromAttributeLocalId(drillDefinition) {
    return drillDefinition.origin.localIdentifier;
}
exports.drillDownFromAttributeLocalId = drillDownFromAttributeLocalId;
function drillDownDisplayForm(drillDefinition) {
    return drillDefinition.target;
}
exports.drillDownDisplayForm = drillDownDisplayForm;
//# sourceMappingURL=ImplicitDrillDownHelper.js.map